<p>pending-announcement works!</p>
